import { Chip, TableCell, TableRow } from "@mui/material"
import { Switch, Case } from "lib/@components/switch"

// HTTP status colour buckets: green for 2xx success, amber for redirects, red for errors
function statusColor(status) {
    if (!status) return "default"
    if (status < 300) return "success"
    if (status < 400) return "warning"
    return "error"
}

// Method badge colours follow REST convention used by tools like Insomnia / Swagger UI
function methodColor(method) {
    switch (method?.toUpperCase()) {
        case "GET":
            return "info"
        case "POST":
            return "success"
        case "PUT":
        case "PATCH":
            return "warning"
        case "DELETE":
            return "error"
        default:
            return "default"
    }
}

function formatTimestamp(ts) {
    if (!ts) return "—"
    return new Date(ts).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", second: "2-digit" })
}

export function FentraLogRow({ entry }) {
    const color = statusColor(entry?.status)
    const method = entry?.method?.toUpperCase() ?? "—"

    return (
        <TableRow hover>
            <TableCell sx={{ whiteSpace: "nowrap", fontFamily: "monospace", fontSize: 11 }}>
                {formatTimestamp(entry?.timestamp)}
            </TableCell>
            <TableCell>
                <Chip size="small" label={method} color={methodColor(entry?.method)} variant="outlined" />
            </TableCell>
            <TableCell sx={{ fontFamily: "monospace", fontSize: 12, wordBreak: "break-all" }}>
                {entry?.path ?? "—"}
            </TableCell>
            <TableCell align="center">
                <Switch value={color}>
                    <Case when="success">
                        <Chip size="small" label={entry?.status} color="success" />
                    </Case>
                    <Case when="warning">
                        <Chip size="small" label={entry?.status} color="warning" />
                    </Case>
                    <Case when="error">
                        <Chip size="small" label={entry?.status} color="error" />
                    </Case>
                    <Case when="default">
                        <Chip size="small" label={entry?.status ?? "—"} />
                    </Case>
                </Switch>
            </TableCell>
            <TableCell align="right" sx={{ fontFamily: "monospace", fontSize: 12 }}>
                {entry?.durationMs != null ? `${entry.durationMs}ms` : "—"}
            </TableCell>
            <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>{entry?.detail ?? ""}</TableCell>
        </TableRow>
    )
}
